<script lang="ts">
	import type { Snippet } from 'svelte';
	import type { Action } from 'svelte/action';

	interface Props {
		children?: Snippet;
		container?: HTMLElement;
		className?: string;
	}

	let { children, container = $bindable(), className = '' }: Props = $props();

	const portal: Action<HTMLElement, string> = (node, targetSelector = 'body') => {
		const targetEl = document.querySelector(targetSelector);
		if (targetEl) {
			targetEl.appendChild(node);
		}
		return {
			destroy() {
				node.remove();
			}
		};
	};
</script>

<div use:portal={'body'} bind:this={container} class={className}>
	{@render children?.()}
</div>
